import { gql } from '@/apollo';

export const CHECK_INSURANCE = gql`
  query CheckInsurance($name: String!) {
    insurances(where: { name: { equals: $name } }) {
      id
      name
    }
  }
`;

export const CHECK_INSURANCE_EXISTS = gql`
  query CheckInsuranceExists($name: String!, $customerName: String) {
    checkInsuranceExists(name: $name, customerName: $customerName) {
      exists
      insurance {
        id
        name
      }
    }
  }
`;

export const CHECK_LOCATION = gql`
  query CheckLocation($city: String!, $state: String!, $zipCode: String, $physicalAddress: String, $customerName: String) {
    checkLocationExists(city: $city, state: $state, zipCode: $zipCode, physicalAddress: $physicalAddress, customerName: $customerName) {
      exists
      location {
        id
        name
        city
        zipCode
        physicalAddress
      }
    }
  }
`;

export const CHECK_CONDITION = gql`
  query CheckCondition($name: String!) {
    conditions(where: { name: { equals: $name } }) {
      id
      name
    }
  }
`;

export const CHECK_CUSTOMER = gql`
  query CheckCustomer($name: String!) {
    customers(where: { name: { equals: $name } }) {
      id
      name
    }
  }
`;

export const CHECK_APPOINTMENT_DETAIL = gql`
  query CheckAppointmentDetail($name: String!, $customerName: String) {
    checkAppointmentDetailExists(name: $name, customerName: $customerName) {
      exists
      appointmentDetail {
        id
        name
      }
    }
  }
`;

export const CHECK_PROVIDER = gql`
  query CheckProvider($firstName: String!, $lastName: String!, $customerName: String!) {
    checkProviderExists(firstName: $firstName, lastName: $lastName, customerName: $customerName) {
      exists
      provider {
        id
        firstName
        lastName
      }
    }
  }
`;

export const IMPORT_INSURANCES = gql`
  mutation ImportInsurances($csvData: String!) {
    importInsurances(csvData: $csvData) {
      success
      message
      importedCount
      skippedCount
      errorCount
      errors {
        row
        field
        value
        message
      }
    }
  }
`;

export const IMPORT_LOCATIONS = gql`
  mutation ImportLocations($csvData: String!) {
    importLocations(csvData: $csvData) {
      success
      message
      importedCount
      skippedCount
      errorCount
      errors {
        row
        field
        value
        message
      }
    }
  }
`;

export const IMPORT_CONDITIONS = gql`
  mutation ImportConditions($csvData: String!) {
    importConditions(csvData: $csvData) {
      success
      message
      importedCount
      skippedCount
      errorCount
      errors {
        row
        field
        value
        message
      }
    }
  }
`;

export const IMPORT_CUSTOMERS = gql`
  mutation ImportCustomers($csvData: String!) {
    importCustomers(csvData: $csvData) {
      success
      message
      importedCount
      skippedCount
      errorCount
      errors {
        row
        field
        value
        message
      }
    }
  }
`;

export const IMPORT_APPOINTMENT_DETAILS = gql`
  mutation ImportAppointmentDetails($csvData: String!) {
    importAppointmentDetails(csvData: $csvData) {
      success
      message
      importedCount
      skippedCount
      errorCount
      errors {
        row
        field
        value
        message
      }
    }
  }
`;

export const IMPORT_PROVIDERS = gql`
  mutation ImportProviders($csvData: String!) {
    importProviders(csvData: $csvData) {
      success
      message
      importedCount
      skippedCount
      errorCount
      errors {
        row
        field
        value
        message
      }
    }
  }
`;
